/**
 * Loading state for the phone frame preview — 3 pulsing dots.
 */
export function PhoneFrameLoadingState() {
  return (
    <div className="flex items-center justify-center gap-2">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="h-2.5 w-2.5 animate-pulse rounded-full bg-gray-300 motion-reduce:animate-none"
          style={{ animationDelay: `${i * 200}ms` }}
        />
      ))}
    </div>
  )
}
